// import axios from 'axios';

// export const OverlayApi = {
//   createNewSession: async (data = {}) => {
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/new-session`,
//         data,
//         {
//           withCredentials: true,
//           headers: {
//             'Content-Type': 'application/json',
//           },
//         }
//       );
//       return response;
//     } catch (error) {
//       console.error(
//         'Error creating session:',
//         error.response?.data || error.message
//       );
//       throw error;
//     }
//   },

//   submitFeedback: async (rating, submitFeedback) => {
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/submit-feedback`,
//         {
//           ratings: rating,
//           feedback_text: submitFeedback,
//         },
//         {
//           withCredentials: true,
//           headers: {
//             'Content-Type': 'application/json',
//           },
//         }
//       );
//       return response;
//     } catch (error) {
//       console.error(
//         'Error submitting feedback:',
//         error.response?.data || error.message
//       );
//       throw error;
//     }
//   },

//   getAllConversations: async () => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/listall`,
//         {
//           withCredentials: true,
//         }
//       );
//       return response.data;
//     } catch (error) {
//       console.error('Error fetching conversations:', error);
//       throw error;
//     }
//   },

//   updateConversation: async (conversation_id, payload) => {
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/${conversation_id}`,
//         payload,
//         {
//           withCredentials: true,
//           headers: {
//             'Content-Type': 'application/json',
//           },
//         }
//       );
//       console.log('response from patch api', response);
//       return response;
//     } catch (error) {
//       console.error('Error updating the conversation', error);
//       throw error;
//     }
//   },

//   deleteOne: async (conversation_id) => {
//     try {
//       const response = await axios.delete(
//         `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/delete-conversation/${conversation_id}`,
//         {
//           withCredentials: true,
//         }
//       );
//       console.log('response after deleting one conversation', response);
//       return response;
//     } catch (error) {
//       console.error('error while deleting the conversation', error);
//       throw error;
//     }
//   },
//   fetchConversation: async (conversation_id) => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/${conversation_id}`,
//         {
//           withCredentials: true,
//         }
//       );

//       return response;
//     } catch (error) {
//       console.error('error loading the conversation', error);
//       throw error;
//     }
//   },

//   fetchInsights: async () => {
//     try {
//       console.log("")
//       const response = await axios.get(
//         `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/insights`,
//         {
//           withCredentials: true,
//         }
//       );

//       return response;
//     } catch (error) {
//       console.error('error loading the insights', error);
//       throw error;
//     }
//   },
// };

import axios from "axios";

export const OverlayApi = {
  createNewSession: async (data = {}) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/new-session`,
        data,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response;
    } catch (error) {
      console.error(
        "Error creating session:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  submitFeedback: async (rating, submitFeedback) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/submit-feedback`,
        {
          ratings: rating,
          feedback_text: submitFeedback,
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response;
    } catch (error) {
      console.error(
        "Error submitting feedback:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  getAllConversations: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/listall`,
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching conversations:", error);
      throw error;
    }
  },

  updateConversation: async (conversation_id, payload) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/${conversation_id}`,
        payload,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("response from patch api", response);
      return response;
    } catch (error) {
      console.error("Error updating the conversation", error);
      throw error;
    }
  },

  deleteOne: async (conversation_id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/delete-conversation/${conversation_id}`,
        {
          withCredentials: true,
        }
      );
      console.log("response after deleting one conversation", response);
      return response;
    } catch (error) {
      console.error("error while deleting the conversation", error);
      throw error;
    }
  },

  fetchConversation: async (conversation_id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/conversation/${conversation_id}`,
        {
          withCredentials: true,
        }
      );

      return response;
    } catch (error) {
      console.error("error loading the conversation", error);
      throw error;
    }
  },

  getRetryMsg: async (msgId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/chat/retrymessage/${msgId}`,
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error retrying message:", error);
      throw error;
    }
  },


  // getJournalEntry: async () => { 
  //   try {
  //     return await axios.get(
  //       `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/journal/listall`,
  //       { withCredentials: true }
  //     );
  //   } catch (error) {
  //     console.error("Error saving the journal entry", error);
  //     throw error;
  //   }
  // },

  getJournalEntry: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/journal/listall`,
        {
          withCredentials: true,
        }
      );
      return response;
    } catch (error) {
      console.error('Error fetching journal:', error);
      throw error;
    }
  },

  // createJournalEntry: async (id, body, title) => {
  //   try {
  //     return await axios.post(
  //       `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/journal/new-journal`,
  //       {
  //         patient_id: id,
  //         message_text: body,
  //         title: title,
  //       },
  //       { withCredentials: true }
  //     );
  //   } catch (error) {
  //     console.error("Error saving the journal entry", error);
  //     throw error;
  //   }
  // },

  createJournalEntry: async (id, body, title) => {
    try {
      console.log("inside the api layer", id, body, title);
      const response = await axios.post(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/journal/new-journal`,
        {
          patient_id: id,
          message_text: body,
          title: title,
        },
        {
          withCredentials: true, // include cookies/session
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Journal created:", response.data);
      return response; // return only the payload, not the whole axios response
    } catch (error) {
      console.error("Error saving the journal entry:", error.response?.data || error.message);
      throw error;
    }
  },

  updateJournal: async (payload, journal_id) => {
    try {
      return await axios.post(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/journal-update/${journal_id}`,
        payload,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      console.error(
        "Error while updating:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  loadJournal: async (id) => {
    try {
      return await axios.get(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/journal/${id}`,
        { withCredentials: true }
      );
    } catch (error) {
      console.error("Error saving the jounral entry", error);
      throw error;
    }
  },

  deleteJournalEntry: async (id) => {
    try {
      console.log("overlay-api", id)
      return await axios.delete(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/journal-delete/${id}`,
        {
          withCredentials: true,
        }
      );
    } catch (error) {
      console.error("Error deleting your journal entry");
    }
  },

  createMood: async (moodData) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/mood/mood-entry`,
        moodData,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response;
    } catch (error) {
      console.error(
        "Error creating session:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  getMood: async () => {
    try {
      return await axios.get(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/mood/mood-summary`,
        { withCredentials: true }
      );
    } catch (error) {
      console.error("Error saving the jounral entry", error);
      throw error;
    }
  },

  fetchInsights: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/insights`,
        {
          withCredentials: true,
        }
      );

      return response;
    } catch (error) {
      console.error('error loading the insights', error);
      throw error;
    }
  },

//check for valid token 
  valiToken: async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/valid-token`,
        {
          withCredentials: true,
        }
      );

      return response;
    } catch (error) {
      console.error('error getting token', error);
      throw error;
    }
  },

  //get latest conversation 
  latestConversation: async (patientid) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/latestConversation`,
        { patient_id: patientid },
        {
          
          withCredentials: true,
        }
      );

      return response;
    } catch (error) {
      console.error('error getting latestConversation', error);
      throw error;
    }
  },

  // createJournalEntry: async (id, body, title) => {
  saveFeedBack: async (feedback, id, tablename) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PATIENT_SERVER_URL}/api/v1/patient/feedback/${id}`,
        {
          feedback: feedback,
          tblename: tablename,
        },
        {
          withCredentials: true, // include cookies/session
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Feed created:", response.data);
      return response; // return only the payload, not the whole axios response
    } catch (error) {
      console.error("Error saving the journal entry:", error.response?.data || error.message);
      throw error;
    }
  },
};

